import { ANTI_FORGERY_FIELD_NAME, HTTP_HEADERS, REQUEST_CREDENTIALS, XSRF_COOKIE_NAME, XSRF_HEADER_NAME } from "./constants";
export async function parseJsonResponse(response) {
    const text = await response.text();
    return text ? JSON.parse(text) : {};
}
export async function readErrorResponse(response, fallback) {
    const message = (await response.text()).trim();
    return message || `${fallback} (${response.status})`;
}
export function getAntiForgeryToken(scope) {
    const selector = `input[name='${ANTI_FORGERY_FIELD_NAME}']`;
    return scope?.querySelector(selector)?.value ?? document.querySelector(selector)?.value ?? null;
}
export function appendAntiForgeryToken(formData, scope) {
    const token = getAntiForgeryToken(scope);
    if (token) {
        formData.append(ANTI_FORGERY_FIELD_NAME, token);
    }
}
export function getCookieValue(name) {
    if (typeof document === "undefined") {
        return null;
    }
    const cookie = document.cookie
        .split(";")
        .map((value) => value.trim())
        .find((value) => value.startsWith(`${name}=`));
    return cookie ? decodeURIComponent(cookie.substring(name.length + 1)) : null;
}
function isSameOrigin(input) {
    if (typeof window === "undefined") {
        return false;
    }
    const requestUrl = typeof Request !== "undefined" && input instanceof Request ? input.url : input.toString();
    return new URL(requestUrl, window.location.href).origin === window.location.origin;
}
export function fetchWithXsrf(input, init = {}) {
    const request = typeof Request !== "undefined" && input instanceof Request ? input : null;
    const method = (init.method ?? request?.method ?? "GET").toUpperCase();
    const headers = new Headers(init.headers ?? request?.headers);
    if (!["GET", "HEAD", "OPTIONS"].includes(method) && isSameOrigin(input)) {
        const token = getCookieValue(XSRF_COOKIE_NAME);
        if (token && !headers.has(XSRF_HEADER_NAME)) {
            headers.set(XSRF_HEADER_NAME, token);
        }
    }
    return fetch(input, { ...init, headers });
}
export async function postForm(url, formData) {
    return fetchWithXsrf(url, {
        method: "POST",
        credentials: REQUEST_CREDENTIALS,
        headers: HTTP_HEADERS.html,
        body: formData
    });
}
